import React, { useEffect, useState } from 'react';
import { Col, Row } from 'components/Core/Grid';
import Text from 'components/Core/Text';
import StyledRichText from 'components/RichText/StyledRichText';
import ContentfulCallToAction from 'components/Contentful/ContentfulCallToAction';
import { WithWistiaContext } from 'utils/WistiaContext';

import { Container } from './styles';

const WistiaCta = ({
  popoverCta,
  ctaBody,
  ctaTitle,
  isModalOpen,
  setIsPlaying,
  videoId,
  videoPlayer,
}) => {
  const [displayCta, toggleDisplayCta] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => {
        toggleDisplayCta(true);
      }, 2500);
    }
  }, [isModalOpen]);

  const handleClick = () => {
    videoPlayer?.pause();
    dataLayer.push({
      event: 'cta clicked',
      label: popoverCta?.buttonLabel,
      cta_text: popoverCta?.buttonLabel,
      cta_position: 'Wistia Video CTA',
      page_title: document.title,
      cta_url: window.location.href,
    });
  };

  return (
    <Container className={`wistia-popover-cta ${displayCta ? 'open' : 'closed'}`}>
      <Row gutter={30}>
        <Col xs={24} sm={18}>
          <h4>{ctaTitle}</h4>
          {ctaBody.raw ? (
            <StyledRichText content={ctaBody} className="wistia-popover-cta--rich-text" />
          ) : (
            <Text type="p">{ctaBody}</Text>
          )}
        </Col>
        <Col xs={24} sm={6} className="wistia-popover-cta--button">
          <ContentfulCallToAction
            {...popoverCta}
            textLabel={null}
            handleClick={handleClick}
            handleClose={() => setIsPlaying(true)}
            isButton
            buttonClass={`wistia-cta-button-${videoId}`}
            videoId={videoId}
            isWistiaCta
          />
        </Col>
      </Row>
    </Container>
  );
};

export default WithWistiaContext(WistiaCta);
